export default {
    // baseURL: 'http://192.168.1.186/',
    // baseURL: 'http://221.176.156.242:60081/',
    baseURL: 'http://221.176.156.242:60080/sw/',
    isDev: true
}